import OrgRecommendations from './OrgRecommendations';

export default OrgRecommendations;
